<template>
  <div class="retry-button" @click="$emit('on-retry-click')">
    <span class="retry-text" v-localize="RETRY_TEXT" />
  </div>
</template>

<script>
import { LocalizationDirective } from '@/directives/LocalizationDirective';

export default {
  name: 'RetryButton',
  created: function() {
    this.RETRY_TEXT = 'Retry'; // :string
  },
  directives: {
    LocalizationDirective,
  },
};
</script>

<style>
.retry-button {
  margin: 0 auto;
  stroke-width: 1pt;
  stroke: rgba(0, 0, 0, 0.04);
  position: relative;
  background-color: #e74c3c;
  line-height: 40px;
  width: 47%;
  border-radius: 25pt;
  text-align: center;
  filter: drop-shadow(0pt 1pt 4pt rgba(0, 0, 0, 0.36));
  -webkit-filter: drop-shadow(0pt 1pt 4pt rgba(0, 0, 0, 0.36));
}

.retry-text {
  font-weight: bold;
  font-size: 17px;
  font-family: 'Avenir Next';
  color: #ffff;
}
</style>
